<template>
	<RectangleTile background="background-transparent" class="offer-basic-information">

		<template v-slot:icon>
			<TileIcon class="tile-icon">
				<SafeImage :src="selectedOffer.icon"></SafeImage>
			</TileIcon>
		</template>


		<template v-slot:details v-if="!isMobileDevice">
			<TileDetails>
				<template v-slot:name>
					<span class="offer-basic-information__name">
						{{ selectedOffer.name }}
					</span>
				</template>
				<template v-slot:description>
					<span class="offer-basic-information__category">
						Categories: <span class="offer-basic-information__category-name">{{ categoryName }}</span>
					</span>
				</template>
			</TileDetails>
		</template>


		<template v-slot:append-bottom v-else>
			<span class="offer-basic-information__name">
				{{ selectedOffer.name }}
			</span>
		</template>


		<template v-slot:actions v-if="!isMobileDevice">
			<span class="offer-basic-information__support">Support: </span>
			<PlatformIcons :offerPlatforms="selectedOffer.platforms"></PlatformIcons>
		</template>


		<template v-slot:append-right>
			<div class="offer-dialog__earning pa-3 rounded-lg"
				style="min-width: 100px;">
				<span class="title">Earn Total</span>
				<span class="coin">
					<v-icon>
						<coin></coin>
					</v-icon>
					<template v-if="coinBoost.hasActiveBoost">
						<span class="text-decoration-line-through mr-1">+{{ abbreviateNumber(coinBoost.originalCoins) }}</span>
						<span class="coin-boosted">↑{{ abbreviateNumber(coinBoost.boostedCoins) }}</span>
					</template>
					<span v-else>+{{ abbreviateNumber(selectedOffer.coins_amount) }}</span>
				</span>
			</div>
		</template>

	</RectangleTile>
</template>



<script setup lang="ts">

import Coin from "@/icons/Coin.vue";
import { calculateBoostedCoins } from '@/utils/coinBoostCalculator';
import { abbreviateNumber } from '@/utils/GlobalMethods';
import { isMobile } from "@/utils/utils";
import { computed } from 'vue';
import { getCategoryName } from "@/utils/utils";
import { Offer } from "@/interfaces/Offers/Offer";
import TileIcon from "@/components/Common/Tile-Icon.vue";
import SafeImage from "@/components/Common/SafeImage.vue";
import TileDetails from "@/components/Common/Tile-Details.vue";
import RectangleTile from "@/components/Tiles/Rectangle-Tile.vue";
import PlatformIcons from "@/components/Common/PlatformIcons.vue";

const isMobileDevice = isMobile();
const props = defineProps({
	offer: {
		type: Object as () => Offer,
		default: null,
	}
});

const selectedOffer = computed(() => props.offer);

const categoryName = computed(() =>
	getCategoryName(selectedOffer.value.category_id)
);

const coinBoost = computed(() => {
	return calculateBoostedCoins(selectedOffer.value.coins_amount);
});

</script>



<style scoped lang="scss">
.coin-boosted {
	color: #F83587;
	font-weight: bold;
}

.offer-basic-information {
	padding: 0px !important;
	border: none !important;

	&__name {
		font-size: 24px;
		font-weight: 600;
	}

	&__category {
		font-size: 15px;
		font-weight: 500;

		&-name {
			font-weight: 700;
		}
	}

	&__support {
		font-size: 15px;
		font-weight: 500;
	}
}

.offer-dialog__earning {
	background-color: rgba(255, 255, 255, 0.1) !important;
	border-top: vars.get-map-value(vars.$border, dialog) !important;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	gap: 6px;

	.title {
		font-size: 12px;
		font-weight: 500;
	}

	.coin {
		font-size: 20px;
		font-weight: 600;
	}
}
</style>